export default "__VITE_ASSET__CGJbF0ty__"